export default __webpack_public_path__ + "images/Dynamics365SVG.svg";